import { Store } from "../../models/Store";

const STORE_IDS_FILTER = "STORE_IDS_FILTER";

export const getFilteredStores = (
  availableStores: ReadonlyArray<Store> = []
): ReadonlyArray<Store> => {
  const ids = window.localStorage.getItem(STORE_IDS_FILTER);
  if (ids) {
    const savedIds = JSON.parse(ids);
    return availableStores.filter(store => savedIds.indexOf(store.id) >= 0);
  }
  return availableStores;
};

export const saveFilteredStoresToLocalStorage = (stores: Store[]): Store[] => {
  const storesIds = stores.map(s => s.id);
  window.localStorage.setItem(STORE_IDS_FILTER, JSON.stringify(storesIds));
  return stores;
};
